/**
 * Google Identity Services (GSI) - 新的 Google 登录 API
 * 参考：https://developers.google.com/identity/gsi/web/guides/migration
 * 注意：旧的 gapi.auth2 已废弃，必须使用新的 GSI API
 */
export const GOOGLE_CLIENT_ID =
  "135086611214-8e1t4e64c7aqjr26fq5g3ru3n8sqqsj3.apps.googleusercontent.com";

export const GSI_SCRIPT_SRC = "https://accounts.google.com/gsi/client";
